<template>
  <div class="swiper_whole">
    <AntEmpty v-show="!data.length" />
    <swiper class="swiper" :options="option" :key="key" @mouseover.native="mouseover" @mouseout.native="mouseout">
      <swiper-slide :class="`swiper_slide`" v-for="(item,index) in data" :key="index">
        <div class="content" @click="submit(item)">
          <img ref="IMG" :src="require('@/assets/images/public/no_img.png')" :data-src="item.img" />
          <div class="standard_number" v-if="item.stdNo">{{item.stdNo}}</div>
          <div :class="additionClass">{{item.name}}</div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
let that = null;
export default {
  props: {
    data: { type: Array, default: () => [] },
    additionClass: { type: String, default: null },
    submit: { type: Function, default: () => null }
  },
  data() {
    return {
      key: 0,
      subsidiary: this.$FN.elVisible(this.fn, { visible: false, rootMargin: "0px" }),
      activeIndex: { index: 0 },
      livingExample: null, //swiper实例
      option: {},
      time: null
    }
  },
  created() {
    that = this;
    this.setOption();
  },
  mounted() {
    this.getRef();
  },
  beforeDestroy() {
    this.clearTime();
  },
  methods: {
    clearTime() {
      clearTimeout(this.time);
      this.time = null;
    },
    getRef() {
      let fn = () => {
        let refs = this.$refs.IMG;
        switch (this.$FN.dataType(refs)) {
          case "Array": return this.subsidiary(refs);
          case "Undefined": return this.time = setTimeout(fn, 300);
        };
      };
      fn();
    },
    fn(target, _, subsidiary) {
      let src = require("@/assets/images/public/no_img.png");
      if (target.dataset.src) src = target.dataset.src;
      target.src = src;
      subsidiary.unobserve(target);
    },
    mouseover() { this.livingExample && this.livingExample.autoplay.stop() },
    mouseout() { this.livingExample && this.livingExample.autoplay.start() },
    setOption() {
      this.option = {
        pagination: '.swiper-pagination',
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: 8.5,
        initialSlide: 0,
        autoHeight: true,
        spend: 300,
        preventClicks: false,
        on: {
          init: function () { that.livingExample = this },
          slideChange: function () {
            // console.log(this.activeIndex, "this.activeIndex");
            // 由于this没有指向vue实例,所以需要activeIndex中转一下
            // that.activeIndex.index = this.activeIndex;
            // let { path = '' } = that.headerList[this.activeIndex];
            // if (path) that.form.moduleId = path;
            // that.getData();
          }
        }
      };
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>